<script setup lang="ts">
  import {
    computed,
    nextTick,
    onActivated,
    onBeforeUnmount,
    onMounted,
    reactive,
    ref,
    watch,
  } from 'vue';
  import {
    actions as actionTypes,
    useUserComponent,
    userComponentProps,
    useHelpers,
    createComponentScope,
    Resource,
    uniqueID,
  } from '@integro/core';
  import type { IAppHelpers } from '@integro/core';
  import * as _ from 'lodash';

  defineOptions({
    name: 'TextTemplates',
  });

  const componentMetadata = {
    kind: 'page',
  };

  const emit = defineEmits(['reload', 'close', 'save']);

  const props = defineProps({
    ...userComponentProps,
  });

  const {
    $app,
    $fn,
    $i18n,
    $store,
    $config,
    $imodal,
    $notification,
    $tabs,
    $route,
    $router,
    gettext,
    pgettext,
    ngettext,
    npgettext,
    schemaDefaults,
    getSchema,
    searchDataSource,
    randomElementId,
    datetime,
    date,
    time,
    number,
    money,
    distance,
    username,
    filesize,
  } = useHelpers();

  const onItemSaved = (...args) => {
    const [data] = args;

    const index = _.indexOf(items.value, { id: data.id });
    if (index > -1) {
      items.value[index] = data;
    } else {
      items.value.push(data);
    }
    selectedItem.value = data;
    createNewItem.value = false;
  };

  const items = ref(null);
  const selectedItem = ref(null);
  const createNewItem = ref(false);
  const ux = ref([]);
  const b_7315092382398562_noShow = computed(() => false);
  const b_7315092382398562_modalBindings = computed(() => ({
    size: 'lg',
  }));

  const $data = computed(() => ({
    items: items.value,
    selectedItem: selectedItem.value,
    createNewItem: createNewItem.value,
    ux: ux.value,
    b_7315092382398562_noShow: b_7315092382398562_noShow.value,
    b_7315092382398562_modalBindings: b_7315092382398562_modalBindings.value,
  }));

  const $$load_items = () => {
    return $fn.value.fetch('list_object_by_type', {
      parameters: { object_type: 'text-templates' },
    });
  };
  const $$load_selectedItem = () => {
    return items.value.length ? items.value[0] : null;
  };

  const {
    loading,
    error,
    loaded,
    reloading,
    showLoadingIndicator,
    loadDataThrottled,
    friendlyName,
    loadData,
    touchLastLoaded,
    handleError,
    setData,
    forms,
    registerForm,
    unregisterForm,
    canLoadData,
    isModalComponent,
    modalName,
    pageDocument: _pageDocument,
    routeTab,
    ux: _ux,
    componentMetadata: _componentMetadata,
    $uid,
    lastLoaded,
  } = useUserComponent(props, {
    metadata: componentMetadata,
    dataSpecs: [
      { name: 'items' },
      { name: 'selectedItem', dependsOn: ['items'] },
      { name: 'createNewItem' },
      { name: 'ux' },
      { name: 'b_7315092382398562_noShow', nodeId: '7315092382398562' },
      { name: 'b_7315092382398562_modalBindings', nodeId: '7315092382398562' },
    ],
    loaders: { items: $$load_items, selectedItem: $$load_selectedItem },
    ux: {},
    dataRefs: {
      items,
      selectedItem,
      createNewItem,
      ux,
      b_7315092382398562_noShow,
      b_7315092382398562_modalBindings,
    },
  });

  const $component = createComponentScope(
    {
      $app,
      $fn,
      $i18n,
      $store,
      $imodal,
      $notification,
      $tabs,
      $router,
    } as IAppHelpers,
    {
      emit,
      forms,
      error,
      isModalComponent,
      modalName,
      componentMetadata,
      loadData,
      registerForm,
      unregisterForm,
      setData,
      touchLastLoaded,
      handleError,
    }
  );

  const pageDocument = computed(() => {
    return null;
  });
  const documentTitle = computed(() => {
    return pageDocument.value
      ? Array.isArray(pageDocument.value.title)
        ? pageDocument.value.title.filter(Boolean).join(' ')
        : pageDocument.value.title
      : null;
  });

  watch(
    pageDocument,
    (newDoc) => {
      if (newDoc) {
        _pageDocument.value = newDoc;
      }
    },
    { immediate: true }
  );

  const act_7315092382398562_closeModal_3c7xnpnq7_getActionArgs = async (
    $event
  ) => {
    return {
      name: props.modalName,
      result: {
        close: true,
        cancel: true,
      },
    };
  };
  const act_3054425420812800_setData_7bvmgetm6_getActionArgs = async (
    $event
  ) => {
    return {
      path: 'createNewItem',
      value: true,
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    };
  };
  const act_3083451129821185_script_kzy9t5rhp_value_callable = async (
    $event
  ) => {
    return onItemSaved($event.data);
  };
  const act_3083451129821185_script_kzy9t5rhp_getActionArgs = async (
    $event
  ) => {
    return {
      value: async () => {
        await act_3083451129821185_script_kzy9t5rhp_value_callable($event);
      },
    };
  };

  const act_7315092382398562_closeModal_3c7xnpnq7 =
    new actionTypes.CloseModalAction({
      actionArgs: act_7315092382398562_closeModal_3c7xnpnq7_getActionArgs,
    });
  const inst_evh_7315092382398562_close_s6rdajqfb =
    new actionTypes.EventHandlerImpl({
      action: act_7315092382398562_closeModal_3c7xnpnq7,
      event: 'close',
      displayName: 'closeModal',
    });
  const inst_evh_7315092382398562_close = new actionTypes.EventHandlerGroup({
    handlers: [inst_evh_7315092382398562_close_s6rdajqfb],
    event: 'close',
  });
  const act_7315092382398562_reloadComponentData_ngeb483kp =
    new actionTypes.ReloadComponentDataAction({});
  const inst_evh_7315092382398562_reload_i6rxkto97 =
    new actionTypes.EventHandlerImpl({
      action: act_7315092382398562_reloadComponentData_ngeb483kp,
      event: 'reload',
      displayName: 'reloadComponentData',
    });
  const inst_evh_7315092382398562_reload = new actionTypes.EventHandlerGroup({
    handlers: [inst_evh_7315092382398562_reload_i6rxkto97],
    event: 'reload',
  });
  const act_8564662037462133_closeComponent_d62z0275s =
    new actionTypes.CloseComponentAction({});
  const inst_evh_8564662037462133_close_vloej506l =
    new actionTypes.EventHandlerImpl({
      action: act_8564662037462133_closeComponent_d62z0275s,
      event: 'close',
      displayName: 'closeComponent',
    });
  const inst_evh_8564662037462133_close = new actionTypes.EventHandlerGroup({
    handlers: [inst_evh_8564662037462133_close_vloej506l],
    event: 'close',
  });
  const act_3054425420812800_setData_7bvmgetm6 = new actionTypes.SetDataAction({
    actionArgs: act_3054425420812800_setData_7bvmgetm6_getActionArgs,
    displayName: 'addNewTextTemplate',
  });
  const inst_evh_3054425420812800_click_rum9uooz7 =
    new actionTypes.EventHandlerImpl({
      action: act_3054425420812800_setData_7bvmgetm6,
      event: 'click',
      displayName: 'addNewTextTemplate',
    });
  const inst_evh_3054425420812800_click = new actionTypes.EventHandlerGroup({
    handlers: [inst_evh_3054425420812800_click_rum9uooz7],
    event: 'click',
  });
  const act_3083451129821185_script_kzy9t5rhp = new actionTypes.ScriptAction({
    actionArgs: act_3083451129821185_script_kzy9t5rhp_getActionArgs,
  });
  const inst_evh_3083451129821185_saved_or9u1u2jy =
    new actionTypes.EventHandlerImpl({
      action: act_3083451129821185_script_kzy9t5rhp,
      event: 'saved',
      displayName: 'script',
    });
  const inst_evh_3083451129821185_saved = new actionTypes.EventHandlerGroup({
    handlers: [inst_evh_3083451129821185_saved_or9u1u2jy],
    event: 'saved',
  });
  const act_2140198529698299_closeComponent_62ave67rw =
    new actionTypes.CloseComponentAction({});
  const inst_evh_2140198529698299_clickPreventStop_rm5vdemsg =
    new actionTypes.EventHandlerImpl({
      action: act_2140198529698299_closeComponent_62ave67rw,
      event: 'click.prevent.stop',
      displayName: 'closeComponent',
    });
  const inst_evh_2140198529698299_clickPreventStop =
    new actionTypes.EventHandlerGroup({
      handlers: [inst_evh_2140198529698299_clickPreventStop_rm5vdemsg],
      event: 'click.prevent.stop',
    });

  const actions = {
    inst_evh_7315092382398562_close_s6rdajqfb,
    inst_evh_7315092382398562_close,
    inst_evh_7315092382398562_reload_i6rxkto97,
    inst_evh_7315092382398562_reload,
    inst_evh_8564662037462133_close_vloej506l,
    inst_evh_8564662037462133_close,
    inst_evh_3054425420812800_click_rum9uooz7,
    addNewTextTemplate: inst_evh_3054425420812800_click_rum9uooz7,
    inst_evh_3054425420812800_click,
    inst_evh_3083451129821185_saved_or9u1u2jy,
    inst_evh_3083451129821185_saved,
    inst_evh_2140198529698299_clickPreventStop_rm5vdemsg,
    inst_evh_2140198529698299_clickPreventStop,
  };

  const evh_7315092382398562_close_s6rdajqfb = async (event, scope) => {
    return await actions.inst_evh_7315092382398562_close_s6rdajqfb.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_7315092382398562_close = async (event, scope) => {
    return await actions.inst_evh_7315092382398562_close.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_7315092382398562_reload_i6rxkto97 = async (event, scope) => {
    return await actions.inst_evh_7315092382398562_reload_i6rxkto97.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_7315092382398562_reload = async (event, scope) => {
    return await actions.inst_evh_7315092382398562_reload.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_8564662037462133_close_vloej506l = async (event, scope) => {
    return await actions.inst_evh_8564662037462133_close_vloej506l.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_8564662037462133_close = async (event, scope) => {
    return await actions.inst_evh_8564662037462133_close.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_3054425420812800_click_rum9uooz7 = async (event, scope) => {
    return await actions.inst_evh_3054425420812800_click_rum9uooz7.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_3054425420812800_click = async (event, scope) => {
    return await actions.inst_evh_3054425420812800_click.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_3083451129821185_saved_or9u1u2jy = async (event, scope) => {
    return await actions.inst_evh_3083451129821185_saved_or9u1u2jy.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_3083451129821185_saved = async (event, scope) => {
    return await actions.inst_evh_3083451129821185_saved.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_2140198529698299_clickPreventStop_rm5vdemsg = async (
    event,
    scope
  ) => {
    return await actions.inst_evh_2140198529698299_clickPreventStop_rm5vdemsg.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_2140198529698299_clickPreventStop = async (event, scope) => {
    return await actions.inst_evh_2140198529698299_clickPreventStop.executeFromDOM(
      $component,
      event,
      scope
    );
  };

  defineExpose({
    documentTitle,
    pageDocument: _pageDocument,
    routeTab,
    loadData,
    loading,
    loaded,
    error,
  });
</script>

<template>
  <ItpPage
    card
    :header="documentTitle"
    :loaded="loaded"
    :noShow="b_7315092382398562_noShow"
    :loading="showLoadingIndicator"
    :reloading="reloading"
    :error="error"
    :modal="modal"
    :modalBindings="b_7315092382398562_modalBindings"
    itp-cname="TextTemplates"
    @close="evh_7315092382398562_close($event, {})"
    @reload="evh_7315092382398562_reload($event, {})"
  >
    <template #header>
      <UcHeader
        :card="!modal"
        :modal="modal"
        :title="pgettext('TextTemplates|header', 'Edit Text Templates')"
        v-if="loaded"
        @close="evh_8564662037462133_close($event, {})"
      >
      </UcHeader>
    </template>
    <UcBody :card="!modal" :modal="modal" v-if="loaded">
      <ItpFormSearchableSelect
        :options="items"
        v-model="selectedItem"
        valueField="id"
        textField="name"
        bind-object
      >
        <template #list-footer>
          <hr />
          <BDropdownItem>
            <a href="#" @click="evh_3054425420812800_click($event, {})">
              {{ pgettext('TextTemplates', 'Add new text template') }}
            </a>
          </BDropdownItem>
        </template>
      </ItpFormSearchableSelect>
      <hr />
      <TextTemplate
        :oid="createNewItem ? null : selectedItem.id"
        class="mt-3"
        v-if="selectedItem || createNewItem"
        @saved="evh_3083451129821185_saved($event, {})"
      >
      </TextTemplate>
    </UcBody>
    <template #footer>
      <UcFooter :card="!modal" :modal="modal" v-if="loaded">
        <ItpButton
          :text="gettext('Close')"
          variant="default"
          @click.prevent.stop="
            evh_2140198529698299_clickPreventStop($event, {})
          "
        >
        </ItpButton>
      </UcFooter>
    </template>
  </ItpPage>
</template>
